/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useNavigate } from "react-router-dom";

const ProductCard = ({ _id, name, price, image, cover }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // console.log("ProductCard clicked with _id:", _id);
    // console.log("Type of _id:", typeof _id);
    navigate(`/collections/${_id}`);
  };

  return (
    <div
      className="CARD  col gap-4 items-center cursor-pointer hover:shadow-2xl transition2 shadow-zinc-300/80 pb-4 z-[9999]"
      onClick={handleClick}
    >
      {/* Image */}
      <div
        style={{ backgroundImage: `url(${cover})` }}
        className="w-[90%]  h-[410px] lg:h-[380px] bg-zinc-50 rounded-t-full mt-4  border border-prime-red overflow-clip bg-cover bg-center saturate-150"
      ></div>
      {/* Details */}
      <div className="details  w-full col gap-2 items-center">
        <p className="text-xl md:text-2xl playfair-display text-prime-red  italic">
          {name}
        </p>
        <div className="centered-row md:text-xl gap-20 md:mt-4">
          <strong>$ {price}</strong>{" "}
          <button className="uppercase bg-prime-red px-8 py-2 md:py-3 md:px-10 cursor-pointer hover:bg-transparent hover:text-prime-red hover:border hover:border-prime-red text-zinc-50 transition2 rounded-sm">
            Buy
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
